import i18nFactory from '@yandex-int/i18n';
import { get } from 'lodash';

import { ValidationResultItem } from '../../../typings/common';
import { createErrorsMapper, ErrorsMatcher } from '../../ErrorsMapper/ErrorsMapper';
import { getMinusPhrasesServerErrorMapperCodes } from '../../MinusPhraseService/MinusPhraseService';

import * as keyset from './GroupEditErrorsTextMapper.i18n';

const i18n = i18nFactory(keyset);

export const groupsTextErrorMapper = createErrorsMapper<{}>(
    ({ idx }): Array<ErrorsMatcher<{}>> => [
        {
            path: ['groups', idx, 'name'],
            codes: [
                {
                    code: 'AdGroupDefectIds.Gen.AD_GROUP_NAME_IS_NOT_SET',
                    message: (err: ValidationResultItem): string => {
                        return i18n('name-empty');
                    }
                },
                {
                    code: 'AdGroupDefectIds.Gen.AD_GROUP_NAME_CANT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('name-empty');
                    }
                },
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('name-empty');
                    }
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('name-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'StringDefectIds.MUST_CONTAIN_ONLY_SYMBOLS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('name-prohibited-symbols');
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'pageBlocks'],
            codes: [
                {
                    code: 'CollectionDefectIds.Gen.CANNOT_BE_EMPTY',
                    message: (): string => {
                        return i18n('page-blocks-are-required');
                    }
                },
                {
                    code: 'DefectIds.OBJECT_NOT_FOUND',
                    message: (): string => {
                        return i18n('test-page-error');
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'minusKeywords'],
            codes: getMinusPhrasesServerErrorMapperCodes()
        },
        {
            path: ['groups', idx, 'keywords'],
            codes: [
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-cannot-be-empty');
                    }
                },
                {
                    code: 'CollectionDefectIds.Gen.CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrases-cannot-be-empty');
                    }
                },
                {
                    code: 'PhraseDefectIds.String.TOO_LONG_WORD',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-too-long-word', {
                            word: get(err, `params.allInvalidSubstrings`, ''),
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.String.TOO_MANY_WORDS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-too-many-words', {
                            phrase: get(err, `params.value`, ''),
                            maxWords: get(err, 'params.maxWords', '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.String.TOO_LONG_KEYWORD',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-too-long-keyword', {
                            phrase: get(err, `params.value`, ''),
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.String.ILLEGAL_CHARACTERS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-illegal-characters', {
                            phrase: get(err, `params.allInvalidSubstrings`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.INVALID_QUOTES',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-invalid-quotes', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.INVALID_BRACKETS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-invalid-brackets', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.INCORRECT_USE_OF_PARENTHESIS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-incorrect-use-of-parenthesis', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.INVALID_EXCLAMATION_MARK',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-invalid-exclamation-mark', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.INVALID_PLUS_MARK',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-invalid-plus-mark', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.INVALID_MINUS_MARK',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-invalid-minus-mark', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.INVALID_POINT',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-invalid-point', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.INVALID_APOSTROPHE',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-invalid-apostrophe', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.MINUS_WORD_INSIDE_BRACKETS_OR_QUOTES',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-minus-word-inside-brackets-or-quotes', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.PLUS_MARK_IN_BRACKETS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-plus-mark-in-brackets', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.PLUS_MARK_IN_BRACKETS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-plus-mark-in-brackets', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.NO_PLUS_WORDS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-no-plus-words', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.String.NOT_SINGLE_MINUS_WORD',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-not-single-minus-word', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.String.MINUS_WORD_DELETE_PLUS_WORD',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-minus-word-delete-plus-word', {
                            phrase: get(err, `params.value`, ''),
                            word: get(err, 'params.allInvalidSubstrings', '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.Gen.ONLY_STOP_WORDS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('phrase-only-stop-words', {
                            phrase: get(err, `params.value`, '')
                        });
                    }
                },
                {
                    code: 'PhraseDefectIds.String.TOO_LONG_MINUS_WORD',
                    message: (err: ValidationResultItem): string => {
                        const errorMinusWord = get(err, 'params.allInvalidSubstrings', '');

                        return i18n('phrase-minus-keywords-max-length', {
                            minusWord: `${errorMinusWord.slice(0, 20)}...`,
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'KeywordDefectIds.Keyword.MAX_KEYWORDS_PER_AD_GROUP_EXCEEDED',
                    message: (err: ValidationResultItem): string => {
                        const count = get(err, 'params.maxKeywords', '');

                        return i18n('key-words-limit', {
                            count
                        });
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'regionIds'],
            codes: [
                {
                    code: 'DefectIds.CANNOT_BE_NULL',
                    message: (err: ValidationResultItem): string => {
                        return i18n('geo-empty-regions');
                    }
                },
                {
                    code: 'RegionIdDefectIds.Gen.EMPTY_REGIONS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('geo-empty-regions');
                    }
                },
                {
                    code: 'RegionIdDefectIds.Gen.NO_PLUS_REGIONS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('geo-no-plus-regions');
                    }
                },
                {
                    code: 'RegionIdDefectIds.RegionIds.INCORRECT_REGIONS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('geo-ids-incorrect-regions', {
                            regionIds: get(err, 'params.value', '')
                        });
                    }
                },
                {
                    code: 'RegionIdDefectIds.RegionIds.MINUS_REGION_MATCHES_PLUS_REGION',
                    message: (err: ValidationResultItem): string => {
                        return i18n('geo-minus-region-matches-plus-region', {
                            minusRegionIds: get(err, 'params.backendParams.minusRegionIds', ''),
                            regionIds: get(err, 'params.backendParams.regionIds', '')
                        });
                    }
                },
                {
                    code: 'RegionIdDefectIds.Regions.MINUS_REGIONS_WITHOUT_PLUS_REGIONS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('geo-minus-regions-without-plus-regions', {
                            regionIds: get(err, 'params.value', '')
                        });
                    }
                },
                {
                    code: 'AdGroupDefectIds.Geo.BAD_GEO',
                    message: (err: ValidationResultItem): string => {
                        const languageParam = get(err, 'params.backendParams.language', '');
                        const bannerId = get(err, 'params.backendParams.bannerId', '');

                        switch (languageParam) {
                            case 'KAZAKH':
                                return i18n('ad-group-bad-geo-for-kazakh', {
                                    bannerId
                                });
                            case 'UKRAINE':
                                return i18n('ad-group-bad-geo-for-ukraine', {
                                    bannerId
                                });
                            case 'TURKISH':
                                return i18n('ad-group-bad-geo-for-turkish', {
                                    bannerId
                                });
                            case 'BELARUSIAN':
                                return i18n('ad-group-bad-geo-for-belarusian', {
                                    bannerId
                                });
                            default:
                                return i18n('ad-group-bad-geo-for-default', {
                                    bannerId
                                });
                        }
                    }
                },
                {
                    code: 'BannerDefectIds.Gen.INCONSISTENT_CREATIVE_GEO_TO_ADGROUP_GEO',
                    message: (): string => i18n('too-wide-geotargeting-smart')
                }
            ]
        },
        {
            path: ['groups', idx, 'targetingYandexUids'],
            codes: [
                {
                    code: 'DefectIds.INVALID_VALUE',
                    message: (): string => i18n('yandexuids-invalid-value')
                },
                {
                    code: 'CollectionDefectIds.Gen.CANNOT_BE_EMPTY',
                    message: (): string => i18n('yandexuids-cannot-be-empty')
                }
            ]
        },
        {
            path: ['groups', idx, 'level'],
            codes: [
                {
                    code: 'NumberDefectIds.MUST_BE_LESS_THEN_OR_EQUAL_TO_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('invalid-max-value-level', {
                            max: get(err, 'params.max', '')
                        });
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'retargeting'],
            codes: [
                {
                    code: 'RetargetingDefectIds.Nums.MAX_SIZE_IN_ADGROUP',
                    message: (err: ValidationResultItem): string => {
                        return i18n('max-retargetings-size', {
                            count: get(err, 'params.max', '')
                        });
                    }
                },
                {
                    code: 'RetargetingDefectIds.Gen.RETARGETING_CONDITION_NOT_FOUND',
                    message: (err: ValidationResultItem): string => {
                        return i18n('retargeting-condition-not-found');
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'retargetingConditionName'],
            codes: [
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('retargeting-conditions-name-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'StringDefectIds.MUST_CONTAIN_ONLY_SYMBOLS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('retargeting-condition-only-symbols');
                    }
                },
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('retargeting-condition-name-cannot-be-empty');
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'retargetingCondition'],
            codes: [
                {
                    code: 'DefectIds.OBJECT_NOT_FOUND',
                    message: (err: ValidationResultItem): string => {
                        return i18n('incorrect-goal-id');
                    }
                },
                {
                    code: 'CollectionDefectIds.Gen.CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('retargeting-condition-cannot-be-empty');
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'libraryMinusKeywordsIds'],
            codes: [
                {
                    code: 'CollectionDefectIds.Size.SIZE_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('library-list-minus-keywords-max', {
                            maxSize: get(err, 'params.maxSize', '')
                        });
                    }
                },
                {
                    code: 'MinusPhraseDefectIds.Gen.MINUS_WORDS_PACK_NOT_FOUND',
                    message: (err: ValidationResultItem): string => {
                        return i18n('library-list-minus-keywords-object-not-found');
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'generalRate'],
            codes: [
                {
                    code: 'DefectIds.CANNOT_BE_NULL',
                    message: (): string => {
                        return i18n('general-rate-required');
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'common'],
            codes: [
                {
                    code: 'AdGroupDefectIds.Number.MAX_ADGROUPS_IN_CAMPAIGN',
                    message: (): string => {
                        return i18n('max-groups-in-campaign');
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'targetTags'],
            codes: [
                {
                    code: 'DefectIds.INVALID_VALUE',
                    message: (): string => {
                        return i18n('tags-invalid-value');
                    }
                },
                {
                    code: 'CollectionDefectIds.Size.SIZE_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('tags-keywords-max', {
                            maxSize: get(err, 'params.maxSize', '')
                        });
                    }
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('tags-keyword-length-max', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'CollectionDefectIds.Gen.MUST_NOT_CONTAIN_DUPLICATED_ELEMENTS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('tags-duplicated-error');
                    }
                }
            ]
        },
        {
            path: ['groups', idx, 'pageGroupTags'],
            codes: [
                {
                    code: 'DefectIds.INVALID_VALUE',
                    message: (): string => {
                        return i18n('tags-invalid-value');
                    }
                },
                {
                    code: 'CollectionDefectIds.Size.SIZE_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('tags-keywords-max', {
                            maxSize: get(err, 'params.maxSize', '')
                        });
                    }
                },
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('tags-keyword-length-max', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'CollectionDefectIds.Gen.MUST_NOT_CONTAIN_DUPLICATED_ELEMENTS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('tags-duplicated-error');
                    }
                }
            ]
        }
    ],
    error => i18n('default-error', { codeError: error.code })
);
